import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAll(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/HSToolBoxMeetings/get?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSToolBoxMeetings/getsingle?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchPreviousMeeting(farmId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/HSToolBoxMeetings/getpreviousmeeting?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingleReadOnly(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSToolBoxMeetings/GetDetailReadyOnly?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchImage(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSToolBoxMeetings/getimage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSToolBoxMeetings/delete?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    deleteImage(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/HSToolBoxMeetings/deleteImage?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    supervisorReviewed(id, score) {

        const options = {
            method: 'put',
            url: `/umbraco/api/HSToolBoxMeetings/supervisorReviewed?id=${id}&score=${score}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(toolboxMeeting) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSToolBoxMeetings/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: toolboxMeeting
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(toolboxMeeting) {

        const options = {
            method: 'put',
            url: `/umbraco/api/HSToolBoxMeetings/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: toolboxMeeting
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    uploadImage(image, toolboxMeetingId) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSToolBoxMeetings/UploadImage?toolboxMeetingId=${toolboxMeetingId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    uploadJobImage(image) {

        const options = {
            method: 'post',
            url: `/umbraco/api/HSToolBoxMeetings/CreateJobMedia`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }

}